// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./vars.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-about {
    font-size: var(--font-size-medium);
    margin-top: var(--margin-top-medium);
    margin-bottom: 10px;
    font-family: var(--font-family-text);
    font-weight: var(--font-weight);
}

.image-whatsapp{
    cursor: pointer;
    height: 64%;
}

.text-color-sura{
    color: var(--color-sura);
    font-size: 30px;
}

.button__contact:hover {
    border: 1px solid #dfdfdf;
    background-color: #dfdfdf;
}

.text-aboutus{
    font-size: 33px;
    margin-top: var(--margin-top-medium);
    margin-bottom: 10px;
    font-family: var(--font-family-text);
    font-weight: var(--font-weight);
}

.button__contact {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    border: none;
    background-color: #fff;
    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);
    margin-right: 10px;
    margin-left: 10px;
    margin-top: 4px;
    transition: 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.phone-number{
    font-size: var(--font-size-big);
    line-height: 0.5;
    color: var(--color-pink);
    font-family: var(--font-family-text);
}

.text-contact-hour{
    font-family: var(--font-family-text);
    font-size: 24px;
    color: var(--color-sura);
    margin-top: var(--margin-top-medium);
}

.text-contact.hour{
    color: #464646;
    font-size: var(--font-size-small);
    margin-top: 10px;
    margin-bottom: 10px;
    font-family: var(--font-family-text);
    font-weight: var(--font-weight);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/about.css"],"names":[],"mappings":"AAEA;IACI,kCAAkC;IAClC,oCAAoC;IACpC,mBAAmB;IACnB,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,mBAAmB;IACnB,oCAAoC;IACpC,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,sBAAsB;IAGtB,+CAA+C;IAC/C,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;IAChB,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,eAAe;IACf,wBAAwB;IACxB,oCAAoC;AACxC;;AAEA;IACI,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,+BAA+B;AACnC","sourcesContent":["@import url(\"vars.css\");\r\n\r\n.text-about {\r\n    font-size: var(--font-size-medium);\r\n    margin-top: var(--margin-top-medium);\r\n    margin-bottom: 10px;\r\n    font-family: var(--font-family-text);\r\n    font-weight: var(--font-weight);\r\n}\r\n\r\n.image-whatsapp{\r\n    cursor: pointer;\r\n    height: 64%;\r\n}\r\n\r\n.text-color-sura{\r\n    color: var(--color-sura);\r\n    font-size: 30px;\r\n}\r\n\r\n.button__contact:hover {\r\n    border: 1px solid #dfdfdf;\r\n    background-color: #dfdfdf;\r\n}\r\n\r\n.text-aboutus{\r\n    font-size: 33px;\r\n    margin-top: var(--margin-top-medium);\r\n    margin-bottom: 10px;\r\n    font-family: var(--font-family-text);\r\n    font-weight: var(--font-weight);\r\n}\r\n\r\n.button__contact {\r\n    border-radius: 50%;\r\n    width: 50px;\r\n    height: 50px;\r\n    border: none;\r\n    background-color: #fff;\r\n    -webkit-box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);\r\n    -moz-box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);\r\n    box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.2);\r\n    margin-right: 10px;\r\n    margin-left: 10px;\r\n    margin-top: 4px;\r\n    transition: 0.3s;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.phone-number{\r\n    font-size: var(--font-size-big);\r\n    line-height: 0.5;\r\n    color: var(--color-pink);\r\n    font-family: var(--font-family-text);\r\n}\r\n\r\n.text-contact-hour{\r\n    font-family: var(--font-family-text);\r\n    font-size: 24px;\r\n    color: var(--color-sura);\r\n    margin-top: var(--margin-top-medium);\r\n}\r\n\r\n.text-contact.hour{\r\n    color: #464646;\r\n    font-size: var(--font-size-small);\r\n    margin-top: 10px;\r\n    margin-bottom: 10px;\r\n    font-family: var(--font-family-text);\r\n    font-weight: var(--font-weight);\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
